import { render, staticRenderFns } from "./SendingForm.vue?vue&type=template&id=8c740c0c&scoped=true&"
import script from "./SendingForm.vue?vue&type=script&lang=js&"
export * from "./SendingForm.vue?vue&type=script&lang=js&"
import style0 from "./SendingForm.vue?vue&type=style&index=0&id=8c740c0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c740c0c",
  null
  
)

export default component.exports